var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWelcome3 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 196,
  height: 237,
  viewBox: "0 0 196 237",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M176.43 200.914h-69.524c-7.128 0-12.906-5.778-12.906-12.905V29.905C94 22.778 99.778 17 106.906 17h69.524c7.127 0 12.905 5.778 12.905 12.905V188.01c0 7.127-5.778 12.905-12.905 12.905z",
  fill: "#BDCBFB"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7BA7B",
  d: "M177.785 138.195h2.7V79.44h-2.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.023 214.056s-49.781 0-75.04-11.052C55.61 191.467 42.452 186.214 38.7 180.1c0 0 100.8 5.4 118.323 33.956z",
  stroke: "#252525",
  strokeWidth: 1.21,
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.888 93.728s-4.277 2.36-10.588 4.472V79.3l10.588 14.428zM191.169 136.492s-7.558 3.696-13.869 5.808l.034-19.84 13.835 14.032zM189.597 45.166c3.603 1.085 6.53 6.631-.668 16.269-3.281 4.392-7.388 9.503-11.596 14.579l.002-26.983c5.283-2.958 9.734-4.627 12.262-3.865zM68.4 145.9l13.599 2.359v24.268c0 7.024 5.611 12.737 12.596 12.901l.31.004 56.414-.001L141.3 231.4l-95.217-7.95L68.4 145.9z",
  fill: "#F7BA7B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.744 78.59c.482.291.898.693 1.255 1.191v85.584c-2.034 4.78-6.88 14.717-10.622 10.967-15.742-15.775-17.852-37.683-13.006-50.39 5.938-15.57 14.45-52.15 22.373-47.352z",
  fill: "#F7BA7B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.428 185.432H94.904c-7.127 0-12.905-5.778-12.905-12.905V14.423c0-7.127 5.778-12.905 12.905-12.905h69.524c7.128 0 12.906 5.778 12.906 12.905v158.104c0 7.127-5.778 12.905-12.906 12.905z",
  stroke: "#252525",
  strokeWidth: 1.44,
  fillOpacity: 0.346,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.032 23.394v-8.971a4.307 4.307 0 0 1 4.302-4.302h10.313M169.16 23.394v-8.971a4.307 4.307 0 0 0-4.301-4.302h-10.313M121.18 10.122h15.486",
  stroke: "#252525",
  strokeWidth: 1.44
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.945 10.694a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0z",
  stroke: "#252525",
  strokeWidth: 0.86,
  fill: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.792 152.35c0 6.213-5.037 11.25-11.25 11.25-6.214 0-11.252-5.037-11.252-11.25 0-6.214 5.038-11.251 11.251-11.251 6.214 0 11.251 5.037 11.251 11.25",
  stroke: "#252525",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.85 121.717c-2.049-2.969-15.479-8.454-16.344 7.726-.705 13.169 9.088 11.608 13.799 9.483 3.392-1.53 8.306-8.86 2.545-17.209z",
  stroke: "#252525",
  strokeWidth: 0.9,
  fill: "#F7BA7B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.782 134.845c1.66-3.737 1.577-6.912 1.215-8.917-.316-1.75-.925-3.15-1.08-3.674",
  stroke: "#252525",
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.182 116.196c2.887-2.347 6.658-12.585-1.052-19.18-2.743-2.346-14.112-3.492-15.223 9.648-1.112 13.14 12.267 12.792 16.275 9.532",
  stroke: "#252525",
  strokeWidth: 0.9,
  fill: "#F7BA7B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.084 93.562c3.393-1.53 8.307-8.86 2.546-17.208-2.05-2.97-15.48-8.455-16.345 7.726-.704 13.168 9.089 11.608 13.8 9.482",
  stroke: "#252525",
  strokeWidth: 0.9,
  fill: "#F7BA7B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.407 236.053H27L38.7 180.1c3.753 6.115 16.91 11.367 43.282 22.904C107.242 214.056 157.5 214.3 157.5 214.3l-3.093 21.753z",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M123.15 15.934c4.989 0 9.07 4.081 9.07 9.068V91.84c0 4.988-4.081 9.07-9.07 9.07l-11.42-.001v23.847l-23.847-23.847H17.015c-4.987 0-9.068-4.08-9.068-9.069V25.002c0-4.987 4.081-9.068 9.068-9.068h106.136z",
  fill: "#FFF",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.052 14.96a.808.808 0 0 1-.572-.238L3.027 13.27a.81.81 0 1 1 1.146-1.145l1.452 1.452a.81.81 0 0 1-.573 1.383M2.863 20.042H.81a.81.81 0 1 1 0-1.62h2.053a.81.81 0 1 1 0 1.62M10.207 12.768a.81.81 0 0 1-.807-.752l-.146-2.049a.81.81 0 0 1 .75-.865.803.803 0 0 1 .865.75l.147 2.049a.81.81 0 0 1-.809.867M88.081 77.902l-1.577-6.88a12.405 12.405 0 0 1-.014-5.486l2.195-9.8c1.958-8.735-2.477-17.464-10.16-21.305.066-.183.141-.36.185-.554a4.638 4.638 0 0 0-9.05-2.027c-.043.194-.05.386-.07.58-8.586.195-16.32 6.197-18.279 14.934l-2.195 9.8a12.417 12.417 0 0 1-2.353 4.954l-4.362 5.55c-1.86 2.365-.615 5.863 2.322 6.52l38.476 8.62c2.937.658 5.555-1.973 4.882-4.906M59.024 80.026c-1.266-.283-2.403.815-2.185 2.094a6.656 6.656 0 0 0 12.018 2.693c.742-1.064.183-2.543-1.083-2.826l-8.75-1.96zM29.477 66.377c-.392 0-.777-.19-1.01-.54-3.855-5.773-5.23-12.7-3.874-19.507 1.357-6.806 5.283-12.677 11.055-16.531a1.214 1.214 0 1 1 1.35 2.02 23.402 23.402 0 0 0-10.022 14.986 23.407 23.407 0 0 0 3.51 17.682 1.214 1.214 0 0 1-1.009 1.89",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.627 62.938c-.392 0-.777-.19-1.011-.54a19.66 19.66 0 0 1-2.95-14.858 19.662 19.662 0 0 1 8.42-12.591 1.214 1.214 0 1 1 1.35 2.02 17.25 17.25 0 0 0-7.387 11.046 17.248 17.248 0 0 0 2.587 13.034 1.215 1.215 0 0 1-1.01 1.89",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.777 59.5c-.392 0-.777-.189-1.01-.54a13.505 13.505 0 0 1-2.028-10.209 13.508 13.508 0 0 1 5.786-8.652 1.216 1.216 0 0 1 1.35 2.02 11.095 11.095 0 0 0-4.753 7.107 11.097 11.097 0 0 0 1.664 8.385 1.215 1.215 0 0 1-1.009 1.89M99.526 83.477a1.216 1.216 0 0 1-.558-2.295c5.59-2.885 9.722-7.776 11.635-13.77a23.404 23.404 0 0 0-1.511-17.964 1.216 1.216 0 0 1 2.16-1.114c3.182 6.167 3.775 13.204 1.665 19.816-2.108 6.613-6.667 12.008-12.834 15.192-.178.091-.37.135-.557.135",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.686 77.976a1.216 1.216 0 0 1-.558-2.295 17.25 17.25 0 0 0 8.575-10.15 17.251 17.251 0 0 0-1.114-13.242 1.216 1.216 0 0 1 2.16-1.115 19.66 19.66 0 0 1 1.27 15.095 19.667 19.667 0 0 1-9.777 11.571 1.215 1.215 0 0 1-.556.136",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.845 72.473a1.216 1.216 0 0 1-.558-2.294 11.093 11.093 0 0 0 5.517-6.53 11.091 11.091 0 0 0-.717-8.519 1.216 1.216 0 0 1 2.16-1.115c3.44 6.662.818 14.882-5.845 18.323a1.215 1.215 0 0 1-.557.135",
  fill: "#252525"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWelcome3);
export default ForwardRef;